import React from 'react';
import { analyticsLogger, PageType } from 'commons/src/analytics';
import { BUILDING_SAVED_SETTINGS } from 'commons/src/analytics/AnalyticsEvents';
import { BuildingType, LocationDetails } from 'commons/src/models/commonTypeScript';
import { toErrorType } from 'commons/src/sagas/isErrorType';
import { useUpdateLocationDetailsMutation } from '../../../api';
import BuildingForm from './BuildingForm';

export type ParentProps = {
    onClose: () => void;
    building: BuildingType;
    locationId: string;
    closeOnSave: boolean;
};

export const EditBuildingComponent = ({
    onClose,
    building,
    locationId,
    closeOnSave,
}: ParentProps): React.ReactElement => {
    const [updateLocationDetails, { isLoading: updateLoading, error }] = useUpdateLocationDetailsMutation();
    const updateError = error ? toErrorType(error) : undefined;
    const onSubmit = async (locationDetails: LocationDetails): Promise<void> => {
        const updatedLocation = { ...locationDetails, id: locationId };
        await updateLocationDetails(updatedLocation).unwrap();
        analyticsLogger(BUILDING_SAVED_SETTINGS, {
            pageType: PageType.Building,
            hasUsageHours: Boolean(locationDetails.usageHours),
            ...locationDetails,
        });
    };

    return (
        <BuildingForm
            building={building}
            updateLoading={updateLoading}
            updateError={updateError}
            saveLocation={onSubmit}
            onClose={onClose}
            closeOnSave={closeOnSave}
        />
    );
};

export default EditBuildingComponent;
